export default __webpack_public_path__ + "files/alert-feac5fab4ca369849d6732393b9a3b56.png";